module.exports = __webpack_public_path__ + "img/1F60A.c6c8bfa1.svg";